import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

const Contact = () => {
  const contact_info = [
    { logo: "mail-open-outline", text: "nahid.parvez.1407@gmail.com" },
    { logo: "call-outline", text: "+88 01711 145 383" },
    {
      logo: "location",
      text: "Dhaka Bangladesh",
    },
  ];

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_u4n16pl",
        "template_cddokoe",
        form.current,
        "dCJuSjr4fHKFgyj7Q",
      )
      .then(
        (result) => {
          toast.success("Successfully Send", { autoClose: 500 });
        },
        (error) => {
          toast.error(error.text, { autoClose: 50000 });
        },
      );
  };

  return (
    <section id="contact" className="py-10 px-3 text-white">
      <div className="text-center my-8">
        <h3 className="text-4xl font-semibold">
          Contact <span className="text-indigo-600">Me</span>
        </h3>
        <div
          className="mt-16 flex md:flex-row flex-col
         gap-6 max-w-5xl bg-gray-800 md:p-6 p-2 rounded-lg mx-auto"
        >
          <form
            ref={form}
            onSubmit={sendEmail}
            className="flex flex-col flex-1 gap-5"
          >
            <input
              type="text"
              placeholder="Your Name"
              name="user_name"
              required
            />
            <input
              type="Email"
              placeholder="Your Email Address"
              name="user_email"
              required
            />
            <textarea placeholder="Your Message" rows={10} required></textarea>
            <button className="px-8 py-3 rounded-md border-2 border-indigo-700 hover:bg-indigo-700 mt-8 font-semibold text-lg transition duration-500">
              Send Message
            </button>
          </form>
          <div className="flex flex-col  gap-5 ">
            {contact_info.map((contact, i) => (
              <div
                key={i}
                className="flex flex-row  
                  text-left gap-4 flex-wrap items-center"
              >
                <div className="min-w-[2.5rem]  text-3xl min-h-[2.5rem] flex items-center justify-center text-white bg-indigo-600 rounded-full">
                  <ion-icon name={contact.logo}></ion-icon>
                </div>
                <p className="md:text-base text-sm  break-words">
                  {contact.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
